import React, {useEffect, useState, useRef} from "react";
import {useParams} from "react-router-dom";
import axiApi from "ApiCaller";
import NavBreadcrum from "components/NavBreadcrum";
import {useTranslation} from "react-i18next";
import moment from "moment";
import ButtonsActions from "views/utils/buttonsActions";
import {useNavigate} from "react-router-dom";
import TopBarActions from "components/TopBarActions";
import navs from "../../navs";
import Spinner from "components/loaders/spinner";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import IconBool from "components/IconBool";

const buttonsActions = new ButtonsActions();

const PluginExport = () => {
    const {token} = useParams();
    const [listExports, setListExports] = useState([]);
    const {t: _Tr} = useTranslation("routes");
    const navigate = useNavigate();
    const [buttonsTB, setButtonsTB] = useState(buttonsActions);
    const items = useRef({
        all: [],
        shown: [],
        chosen: [],
        checkboxes: [],
    });
    const [itemsShow, setItemsShow] = useState([]);
    const [checkboxAll, setCheckboxAll] = useState(false);
    const [loading, setLoading] = useState(true);

    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
    });

    const bread = [
        {name: _Tr("labels.administration"), url: "/administration", current: false},
        {name: _Tr("labels.plugins"), url: "/administration/plugins/", current: false},
        {name: _Tr("labels.exportation"), current: true},
    ];

    useEffect(() => {
        let title = _Tr("labels.exportation");
        document.title = title;
        let buttons = {...buttonsTB};
        buttons.title = title;

        buttons.export.active = true;
        buttons.export.disabled = false;
        buttons.export.onClick = onClickExport;

        // buttons.delete.active = true;
        // buttons.delete.disabled = true;
        // buttons.delete.onClick = onClickDelete;

        setButtonsTB(buttons);
        loadExports();
    }, []);

    const loadExports = () => {
        setLoading(true);
        axiApi
            .get(`/api/plugins/inventory/exports/list/${token}/`)
            .then((resp) => {
                const data = resp.data.exports || [];
                items.current.all = [...data];
                items.current.shown = [...data];
                items.current.chosen = [];
                items.current.checkboxes = [];
                setItemsShow(data);
                setListExports(data);

                let buttons = {...buttonsTB};
                buttons.counter = data.length;
                buttons.title = _Tr("labels.exportation");
                setButtonsTB(buttons);

                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const onClickDelete = () => {
        if (items.current.chosen.length === 0) return;

        AlertQuestion.info(
            "Eliminar",
            `¿Está seguro que desea eliminar ${items.current.chosen.length} exportaciones seleccionadas?`,
        ).then((resp) => {
            if (resp.isConfirmed) {
                const ids = items.current.chosen.map((idx) => items.current.shown[idx].token);

                Alert.success("Eliminar", "Funcionalidad pendiente de implementación");

                loadExports();
            }
        });
    };

    const onClickCheckbox = (e) => {
        const {value, checked} = e.target;
        if (checked) {
            items.current.chosen.push(value);
            items.current.checkboxes.push(e.target);
        } else {
            items.current.chosen = items.current.chosen.filter((item) => item !== value);
            items.current.checkboxes = items.current.checkboxes.filter((item) => item !== e.target);
        }
        // buttons.current.delete.disabled = !(items.current.chosen.length > 0);
        setCheckboxAll(items.current.chosen.length === items.current.shown.length);
    };

    const handleClickAll = (e) => {
        let checkboxes = document.querySelectorAll("input[type='checkbox'][name='export-item']");
        if (e.target.checked) {
            checkboxes.forEach((item, idx) => {
                item.checked = true;
                if (!items.current.chosen.includes(idx.toString())) {
                    items.current.chosen.push(idx.toString());
                }
            });
            setCheckboxAll(true);
        } else {
            checkboxes.forEach((item) => {
                item.checked = false;
            });
            items.current.chosen = [];
            setCheckboxAll(false);
        }
        // TBbuttons.current.delete.disabled = !(items.current.chosen.length > 0);
    };

    const onClickExport = () => {
        AlertQuestion.info(
            "Exportar",
            "Se exportarán los datos del plugin. Por favor espere a la respuesta en las notificaciones.",
        ).then((resp) => {
            if (resp.isConfirmed) {
                axiApi
                    .post(`/api/plugins/inventory/export/${token}/`)
                    .then((resp) => {
                        if (resp.data.status) {
                            Alert.success("Exportar", "Solicitud de exportación enviada correctamente");
                        } else {
                            Alert.error("Error", resp.data.message || "Error al solicitar la exportación");
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        Alert.error("Error", "Error al comunicarse con el servidor");
                    });
            }
        });
    };

    const onClickLink = (e) => {
        let link = e.target.dataset.link;
        if (!link) {
            Alert.error("Archivo", "No se pudo encontrar la referencia del archivo");
            return false;
        }
        axiApi
            .get(link, {responseType: "blob"})
            .then((resp) => {
                const contentDisposition = resp.headers["content-disposition"];
                const contentType = resp.headers["content-type"];
                let filename = "downloaded-file";
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                    if (filenameMatch.length === 2) {
                        filename = filenameMatch[1];
                    }
                }
                const blob = new Blob([resp.data], {type: contentType});
                const urlBlob = window.URL.createObjectURL(blob);
                const linkTemp = document.createElement("a");
                linkTemp.href = urlBlob;
                linkTemp.setAttribute("download", filename);

                document.body.appendChild(linkTemp);
                linkTemp.click();
                document.body.removeChild(linkTemp);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} />
            <div>
                {loading ? (
                    <Spinner />
                ) : listExports.length === 0 ? (
                    <div className="alert alert-info">No hay exportaciones para mostrar para este plugin.</div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead>
                                <tr>
                                    {/* <th key="-1">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value="all"
                                            checked={checkboxAll}
                                            onChange={handleClickAll}
                                        />
                                    </th> */}
                                    <th>Creada</th>
                                    <th>Email</th>
                                    <th>Estado</th>
                                    <th>Finalizada</th>
                                    <th>Archivo</th>
                                    <th>Tamaño</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itemsShow.map((item, index) => (
                                    <tr key={item.token || index}>
                                        {/* <td>
                                            <input
                                                type="checkbox"
                                                name="export-item"
                                                value={index}
                                                checked={items.current.chosen.includes(
                                                    index.toString()
                                                )}
                                                onChange={onClickCheckbox}
                                            />
                                        </td> */}
                                        <td>{moment(item.created).format("DD/MM/YYYY HH:mm")}</td>
                                        <td>{item.email}</td>
                                        <td>
                                            <IconBool value={item.verified} />
                                        </td>
                                        {/* <td>{item.verified ? "Completado" : ""}</td> */}
                                        <td>{item.ended ? moment(item.ended).format("DD/MM/YYYY HH:mm") : ""}</td>
                                        <td>
                                            {item.link ? (
                                                <button
                                                    type="button"
                                                    data-link={item.link}
                                                    className="btn btn-link p-0 m-0"
                                                    onClick={onClickLink}>
                                                    Descargar {item.filename}
                                                </button>
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                        <td>{item.size || "-"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </>
    );
};

export default PluginExport;
